import { Action } from '@ngrx/store';

export function getSelctedConceptType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Get Selection ${(type as any).$typeName}`;
}

export class GetSelctedConceptAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { key: string, code: string }) {
    this.type = getSelctedConceptType(module, modelType);
  }
}






// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/GetSelctedConceptAction.ts